export const ANIMATION_VARIANTS = {
  enter: (dir: 1 | -1) => ({ opacity: 0, y: dir === 1 ? 10 : -10 }),
  center: { opacity: 1, y: 0 },
  exit: (dir: 1 | -1) => ({ opacity: 0, y: dir === 1 ? -10 : 10 })
};
